<template>
    <div class="container" v-title="'绑定手机号'">
        <Navigation-bar></Navigation-bar>
        <div class="container_content">
            <Title :title="oldPhoneText" subtitle="当前绑定手机号"></Title>
            <div id="ChangePhone" >
                <div class="content">
                    <ul>
                        <li>
                            <p class="hint" v-text="form.phoneHint"></p>
                            <div class="item-input">
                                <input type="number" pattern="\d*" :disabled="countDown != 0" v-model.trim="form.phone" @blur="phoneBlur()" maxlength="11" placeholder="请输入手机号">
                            </div>
                        </li>
                        <li>
                            <div class="item-input">
                                <input type="tel" pattern="\d*" :class="{'error' : form.codeHint}" v-model.trim="form.code" @blur="codeBlur()" maxlength="6" placeholder="请输入验证码">
                                <span v-if="!form.codeDisabled" class="text-btn" :class="UserType == 1?'s':'c'" @click="sendCode()">获取验证码</span>
                                <span v-else class="text-btn" style="color: #1B1C1E;" v-text="countDownText"></span>
                            </div>
                            <p class="errorHint" v-text="form.codeHint"></p>
                        </li>
                    </ul>
                </div>
                <div class="ChangePhone_hint">
                    <YD-image src="icon/icon_提示_灰色"></YD-image>
                    <p>更换手机号码后，下次登录可<br>使用新手机号码登录</p>
                </div>
                <div class="operation">
                    <button @click="send()">确认</button>
                </div>
            </div>
        </div>
        <Alert-tip :tipData="alertTip" :tipShow="tipShow" @closeCallback="tipShow = false"  @btnCallback="tipShow = false"></Alert-tip>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
    SendVerificationCodeForUserChangeMobile,
    UserChangeMobile
} from "@/api"
import {
    textEncryption
} from '@js';
import {
    closeWebView,
    resetToken
} from "@js/appInteraction"
export default {
    name:"ChangePhone",
    data(){
        return {
            oldPhone:'',
            form:{
                phone:"",
                phoneHint:"",
                code:"",
                codeHint:"",
                codeDisabled:true,
            },
            VerificationSerialNumber:"",
            token:"",
            countDown: 0,
            timer: null,
            alertTip:{
                title:"温馨提示",
                text:"输入的新手机号与当前绑定手机号相同",
                btnArr:["我知道了"]
            },
            tipShow:false
        }
    },
    created(){
        if(this.$store.state.UserInfo.MobileNumber){
            let MobileNumber = this.$store.state.UserInfo.MobileNumber;
            this.oldPhone = MobileNumber;
        }
    },
    beforeDestroy(){
        clearInterval(this.timer);
    },
    computed:{
        ...mapGetters(['UserType']),
        countDownText:function(){
            return this.countDown ? this.countDown + "s" : "";
        },
        oldPhoneText:function(){
            return textEncryption(this.oldPhone, 3, 4, '****');
        }
    },
    watch:{
        "form.phone":function(){
            this.form.phoneHint = "";
            this.form.codeDisabled = true;
            if(this.form.phone.length == 11){
                if(this.form.phone.substr(0,1) == "1"){
                    this.form.codeDisabled = false;
                }else{
                    this.form.phoneHint = "请输入正确的格式";
                }
            }else if(this.form.phone.length > 11){
                this.form.phoneHint = "请输入正确的格式";
            }
        },
        "form.code":function(){
            this.form.codeHint = ""; 
            if(this.form.code.length > 6){
                this.form.codeHint = "验证码错误"; 
            }
        }
    },
    methods:{
        phoneBlur(){
            if(this.form.phone.length != 11 || this.form.phone.substr(0,1) != "1"){
                this.form.phoneHint = "请输入正确的格式";
                return false;
            }
        },
        codeBlur(){
            if(this.form.code.length != 6){
                this.form.codeHint = "验证码错误";
                return false;
            }
        },
        sendCode(){
            if(this.phoneBlur() == false){
                return;
            }
            SendVerificationCodeForUserChangeMobile({
                MobileNumber: this.form.phone
            }).then(data=>{
                if(data.Code == 0){
                    this.VerificationSerialNumber = data.VerificationSerialNumber;
                    this.countDown = 60;
                    this.form.codeDisabled = true;
                    clearInterval(this.timer);
                    this.timer = setInterval(() => {
                        this.countDown--;
                        if(this.countDown <= 0){
                            this.form.codeDisabled = false;
                            clearInterval(this.timer);
                        }
                    }, 1000);
                }
            })
        },
        send(){
            if(this.phoneBlur() == false || this.codeBlur() == false){
                return;
            }
            if(this.form.phone == this.oldPhone){
                this.tipShow = true;
                return;
            }
            UserChangeMobile({
                MobileNumber: this.form.phone,
                VerificationSerialNumber: this.VerificationSerialNumber,
                InputVerificationCode: this.form.code
            }).then(data=>{
                if(data.Code == 0){
                    this.$Toast('修改手机号成功','success');
                    setTimeout(()=>{
                        resetToken({UserType:0});
                        closeWebView(2);
                    },1000)
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
#ChangePhone{
    .content{
        max-height: 632px;
        min-height: 400px;
        height: 60%;
        padding: 0 40px 0;
        box-sizing: border-box;
        ul{
            li{
                width: 670px;
                margin: 0 auto;
                margin-bottom: 32px;
                .item-input{
                    width: 670px;
                    height: 112px;
                    position: relative;
                    input{
                        width: 100%;
                        height: 100%;
                        background: #F9F9F9;
                        border-radius: 20px;
                        padding: 0 32px;
                        font-size: 32px;
                        box-sizing: border-box;
                        &.error{
                            background: rgba(240,110,67,0.1);
                        }
                    }
                    .text-btn{
                        @include line-height(40px);
                        font-size: 28px;
                        font-weight: 500;
                        text-align: right;
                        position: absolute;
                        right: 32px;
                        top: 50%;
                        margin-top: -20px;
                        &.s{
                            color: #7AD21A;
                        }
                        &.c{
                            color: #FFA61C;
                        }
                    }
                }
                .hint,
                .errorHint{
                    @include line-height(40px);
                    font-size: 28px;
                    font-weight: 400;
                }
                .hint{
                    color: #8B8C8D;
                    margin-bottom: 8px;
                }
                .errorHint{
                    color: #F06E43;
                    margin-top: 8px;
                }
            }
        }
    }
    .ChangePhone_hint{
        text-align: center;
        img{
            width: 52px;
            height: 52px;
        }
        p{
            font-size: 28px;
            color: #8B8C8D;
            line-height: 42px;
            font-weight: 400;
            margin-top: 8px;
        }
        
    }
    .operation{
        height: 92px;
        width: 100%;
        margin-top: 80px;
        button{
            @include btn-type-large;
            background: #F5F7F5;
            color: #1B1C1E;
        }
    }
}
</style>